import styled from "styled-components";
import { Breakpoints } from "styles/breakpoints";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const DropdownNavItem = styled.li`
  @media (max-width: ${Breakpoints.Small}) {
    width: 100%;
  }
`;

export const DropdownIconWrapper = styled.span`
  display: inline-flex;
  margin-left: 8px;
  transform: scaleY(1);

  @media (max-width: ${Breakpoints.Small}) {
    margin-left: auto;
    margin-right: 16px;
  }

  .has-dropdown.is-open & {
    transform: scaleY(-1);
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 184px;
  right: 0;
  background-color: ${colours.white};
  padding: 24px 12px;

  @media (max-width: ${Breakpoints.Large}) {
    left: 180px;
  }

  @media (max-width: ${Breakpoints.Medium}) {
    left: 152px;
  }

  @media (max-width: ${Breakpoints.Small}) {
    position: static;
    left: 0;
    background-color: transparent;
    padding: 0 0 1rem 0;
    border-bottom: 1px solid white;
    display: none;

    .has-dropdown.is-open & {
      display: block;
    }
  }
`;

export const DropdownTitle = styled.div`
  font-weight: ${fontWeights.heavy};
  text-transform: uppercase;
  letter-spacing: 0.15em;
  margin-left: 1.2em;
  margin-bottom: 1em;

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover,
  a:focus {
    text-decoration: underline;
  }

  @media (max-width: ${Breakpoints.Small}) {
    display: none;
  }
`;

export const StyledLink = styled.li`
  padding: 0;

  @media (max-width: ${Breakpoints.Small}) {
    width: 100%;
  }
`;

export const StyledNavButton = styled.button`
  border: none;
  background-color: ${colours.elexonBlue};
  position: relative;
  height: 100%;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colours.white};
  line-height: 150%;
  padding: 0 24px;
  text-transform: capitalize;
  letter-spacing: 0.15em;
  white-space: nowrap;

  @media (max-width: ${Breakpoints.Large}) {
    padding: 0 16px;
    letter-spacing: 0.1em;
  }

  @media (max-width: ${Breakpoints.Medium}) {
    font-size: 0.8em;
    padding: 0 12px;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 14px;
    left: 12%;
    width: 0;
    height: 1px;
    background-color: ${colours.white};
    transition: width 0.3s ease;
  }

  &:hover {
    cursor: pointer;

    &::after {
      width: 75%;
    }
  }

  @media (max-width: ${Breakpoints.Small}) {
    width: 100%;
    justify-content: space-between;
    padding: 12px 0 12px 16px;
    font-size: 16px;
    letter-spacing: 0.15em;

    &::after {
      display: block;
      bottom: 3px;
      left: 0;
      width: 0;
    }

    &:hover {
      &::after {
        width: 100%;
      }
    }
  }
`;
